<template>
    <div class="main-box" style="height:600px;">
        <xr-table ref="xrTable" :configure="configure"></xr-table>
    </div>
</template>

<script>

  export default {
    // userAdd
    name: 'interfaceCategorySelect',
    data() {
      return {
        isProjectViewShow: false,
        configure: {
          url: '/web/service?method=tGeneratePage_list',
          isShowSearch: true,
          pagination: true, //允许分页（默认true）
          listParam:{
            notPageId: '-1',
            isViewFull: '0'
          },
          // editUrl: '/web/service?method=tCalProject_edit',
          idField: 'id',
          tableHeight: 500,
          defaultNoLoadData: true,
          isSelectFirst: true,
          that: this,
          columns: [
            {
              field: 'radio',
              width: 60,
            },
            {
              field: 'categoryName',
              title: '模块名称',
              width: 300,
              condition: {
                searchType: 'input',
                searchName: 'categoryNameSearch',
                value:''
              },
            },
            {
              field: 'pageName',
              title: '页面名称',
              width: 300,
              condition: {
                searchType: 'input',
                searchName: 'pageNameSearch',
                value:''
              },
            },
            {
              field: 'categoryCode',
              title: '数据源编码',
              width: 380,
              condition: {
                searchType: 'input',
                searchName: 'categoryCodeSearch',
                value:''
              },
            },
            {
              field: 'createTime',
              title: '创建时间',
              condition: {
                searchType: 'input',
                searchName: 'createTimeSearch',
                value:''
              },
            }
          ],
          toolbar: [
            {
              text: '确定',
              iconCls: 'wk wk-confirm',
              that: this,
              handler: function () {
                this.that.handleAddOpenDialog();
              }
            },{
              text: '取消',
              iconCls: 'wk wk-cancel2',
              that: this,
              handler: function () {
                this.that.$emit('cancelMethod');
              }
            },
            {
              toolType: 'checkAll',
              text: '全部',
              iconCls: 'wk wk-edit',
              that: this,
              handler: function (value) {
                this.that.isViewFull(value)
              }
            }
          ],
          onClickRow: function(row){
          }
        }
      }
    },
    components: {

    },
    methods: {
      init(pageId){
        this.configure.listParam['notPageId'] = pageId;
        this.$nextTick(()=>{
          this.$refs.xrTable.getData();
        })
      },
      handleAddOpenDialog(){
        let row = this.$refs.xrTable.radio_row;
        if(!row){
          this.$message.warning('请选择一条数据！')
          return false;
        }
        this.$emit('confirmMethod',row);
      },
      //显示全部
      isViewFull(value){
        this.configure.listParam['isViewFull'] = value;
        this.$nextTick(()=>{
          this.$refs.xrTable.getData();
        })
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/PageSelect/generate/pageSelect.vue